export default __webpack_public_path__ + "static/media/trend-top.6a2b4f71.png";